import { applyCustomBrandColor } from 'shared/helpers/brandColor';

// Applies an account's effective white-label branding (or resets to the
// installation defaults when the account carries none).
export const applyAccountBranding = (store, account) => {
  const branding = account?.branding || null;
  store.commit('globalConfig/setBrandingOverride', branding);

  // Always repaint the accent palette: the account's custom color when present,
  // otherwise the installation default (the same value applied at boot). This
  // ensures switching back from a branded account clears the previous custom
  // palette instead of leaving it stuck on the CSS variables.
  const color =
    branding?.brand_color || window?.globalConfig?.BRAND_PRIMARY_COLOR;
  applyCustomBrandColor(color);
};

export default applyAccountBranding;
